import { Component, OnInit, HostListener, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { SpinnerService } from 'src/app/services/spinner.service';
import { setConfigTable, setConfigTableModalBusqueda } from 'src/app/shared/utils';

@Component({
  selector: 'app-modal-busqueda-proveedor',
  templateUrl: './modal-busqueda-proveedor.component.html',
  styleUrls: ['./modal-busqueda-proveedor.component.css']
})
export class ModalBusquedaProveedorComponent implements OnInit {

  @Input() proveedores: [];
  position: number = 1;
  index: number = 0;

  //dtTrigger: Subject<null> = new Subject();
  //dtOptions: any = {};

  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  constructor(private modalService: NgbActiveModal,
     private spinnerService: SpinnerService) { };


  ngOnInit(): void {
    //console.log('Modal')
    //console.log(this.proveedores)

    /*timerOut(10).then((value: any) => {
      if (value) { this.codArticuloInput.nativeElement.focus(); }
    });*/

    //this.dtOptions = setConfigTableModalBusqueda(false);
    this.position = 0;
    this.index = this.proveedores.length - 1;
    setTimeout(() => {
      //this.dtTrigger.next();
      this.spinnerService.activarLoading(false);
    }, 800);


  }

  onClick(data: any): void {
    this.spinnerService.activarLoading(true);
    console.log(data)
    this.modalService.close(data);
  }

  cancelar(): void {
    this.modalService.dismiss('canceling');
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    let x = event.keyCode;

    if (this.proveedores.length > 0) {
      if (x === 13) {//enter 13
        this.onClick(this.proveedores[this.position])
      }

      if (x === 38) {//38 arriba
        if (this.position > 0) {
          this.position--;
          // console.log(this.position)
          // console.log(this.articulos[this.position])
        }
      }

      if (x === 40) {//40 abajo
        if (this.position < this.index) {
          this.position++;
          // console.log(this.articulos[this.position])
          // console.log(this.position)
        }
      }
    }
  }

}
